import * as types from '../constants/ActionTypes'
import UserService from "../api/UserService"
import md5 from "../lib/m_c_md5"
import * as cookies from "../lib/cookies"
import { openSnackbar } from "./snackbar"
import { clearPopup, closePopup, openPopup } from './popup'

import ProfileEdit from '../components/ProfileEdit'

export function setUser(user) {
  console.log("[USER] объект пользователя установлен")
  const role = user.object.ae9dd1b1032daaed7cc9638180dc6318b.UserType.key;
  console.log("[USER] роль: ", role)

  return {
    type: types.USER_LOGIN,
    role,
    user
  }
}

export function checkSession(uid) {
  console.log("[USER] Проверка сессии пользователя")
  return (dispatch) => {
    UserService.checkSession(uid).then(response => {
      if (response.data.ok === true) {
        console.log("[USER] Сессия действительна")
        dispatch(getCurrentUserData(uid))
        dispatch(closePopup())
      } else {
        console.log("[USER] Сессия недействительна. Очистка данных пользователя")
        dispatch(clearStore())
      }
    })
  }
}
export function clearStore() {
  return (dispatch) => {
    dispatch(closePopup())
    dispatch(clearUser())
    dispatch(clearPopup())
  }
}

export function clearUser() {
  cookies.deleteCookie('uid')
  return {
    type: types.USER_CLEAR,
    user: {}
  }
}

export function getCurrentUserData(uid, isEdit = false) {
  return (dispatch) => {
    UserService.getCurrentUserData(uid).then(response => {
      console.log("[USER] Данные пользователя получены: ")

      cookies.setCookie('uid', uid)
      console.log("[USER] UID установлен в cookies")

      dispatch(setUser(response.data.object))
      if (isEdit) {
        dispatch(openPopup('Редактирование профиля', <ProfileEdit />))
      }
    }).catch(err => {
      console.log("[USER] Ошибка при получении данных пользователя: ", err)
      dispatch(clearStore())
    })
  }
}

export function userRefresh() {
  return async(dispatch) => {
    const uid = cookies.getCookie('uid')
    if (uid) {
      console.log("[USER] Запись о пользователе существует. Обновить данные")
      dispatch(checkSession(uid))
    } else {
      console.log("[USER] Запись о пользователе отсутствует. Выполните вход")
      dispatch(clearStore())
    }
  };
}

export function updateUser(data, pass) {
  return (dispatch) => {
    UserService.updateUser(data).then(response => {
      if (response.data.ok) {
        if (pass) {
          dispatch(clearStore())
          dispatch(openPopup("Обновление данных", (
            <div className="auth-restorePasswordForm">
              <p className='auth-label clr-white fs-14'>
                Вы успешно обновили свой пароль <br />
                Повторно войдите в аккаунт
              </p>
            </div>
          )))
        } else {
          dispatch(getCurrentUserData(response.data.id))
          dispatch(openSnackbar("Данные обновлены", "success"))
          dispatch(setUser(data))
        }
      }
      else {
        dispatch(openSnackbar("Ошибка при обновлении данных. Попробуйте позже", "error"))
      }
    }).catch(() => {
      dispatch(openSnackbar("Ошибка сети", "error"))
    })
  }
}

export function createUser(data) {
  return (dispatch) => {
    UserService.createUser(data).then(response => {
      if (response.data.ok) {
        dispatch(clearPopup());
        dispatch(openPopup("Регистрация ", (
          <div className="auth-restorePasswordForm">
            <p className='auth-label clr-white fs-14'>
              Для завершения регистрации перейдите <br />
              по ссылке в письме на Вашей <br />
              электронной почте - {data.email}
            </p>
          </div>
        )))
        //dispatch(openSnackbar("Данные сохранены. Для завершения регистрации перейдите по ссылке в письме на Вашей электронной почте", "success"))
      }
      else dispatch(openSnackbar(response.data.error, "error"))
    }).catch(() => dispatch(openSnackbar("Ошибка сети", "error")))
  }
}

export function restoreChangePassword(id, password) {
  return (dispatch) => {
    const md5password = md5(password);
    UserService.restorePasswordChange(id, md5password).then(response => {
      console.log(response)
      if (response.data.ok) {
        dispatch(openSnackbar("Пароль успешно изменён", "success"));
        dispatch(clearPopup());
        dispatch(clearStore())
        window.location.replace('https://hcvf.ru');
      } else {
        dispatch(openSnackbar(`Произошла ошибка во время изменения пароля: ${response.data.error}`, "error"))
        window.location.replace('https://hcvf.ru');
      }
    }).catch(() => {
      dispatch(openSnackbar("Ошибка сети", "error"));
      window.location.replace('https://hcvf.ru');
    })
  }
}